export const frozenYogurtProducts = [
    {
      name: "Natural",
      category: "Frozen Yogurt",
      image: "/frozzen/frozzen-natural.png",
      description:
        "Base versátil para restaurantes que querem uma sobremesa leve e fácil de vender.",
    },
    {
      name: "Papaya",
      category: "Frozen Yogurt",
      image:
        "/frozzen/frozzen-papaya.png",
      description:
        "Sabor tropical, refrescante e com excelente apelo para o pós-refeição.",
    },
    {
      name: "Matcha",
      category: "Personalizado",
      image:
        "/frozzen/frozzen-matcha.png",
      description:
        "Opção com conexão direta ao universo oriental e excelente encaixe no japonês.",
    },
    {
      name: "Gengibre",
      category: "Personalizado",
      image:
        "/frozzen/frozzen-gengibre.png",
      description:
        "Sabor marcante, sofisticado e alinhado com a experiência gastronômica japonesa.",
    },
    {
      name: "Lichia",
      category: "Personalizado",
      image:
        "/frozzen/frozzen-lichia.png",
      description:
        "Leve, diferente e com forte percepção premium no cardápio.",
    },
  ];
  
  export const iceCreamProducts = [
    {
      name: "Chocolate Dark",
      category: "Sorvete 10L",
      image:
        "/massa/dark.png",
      description:
        "Sabor intenso e clássico, ideal para sobremesas de alta saída.",
    },
    {
      name: "Doce de Leite com Cookies",
      category: "Sorvete 10L",
      image:
        "/massa/doce-de-leite.png",
      description:
        "Cremoso, indulgente e perfeito para criar sobremesas com maior valor percebido.",
    },
    {
      name: "Açaí",
      category: "Sorvete 10L",
      image:
        "/massa/acai.png",
      description:
        "Produto com grande aceitação e excelente potencial de venda recorrente.",
    },
    {
      name: "Jabuticaba",
      category: "Sorvete 10L",
      image:
        "/massa/jabuticaba.png",
      description:
        "Sabor brasileiro, diferente e ótimo para destacar o cardápio.",
    },
    {
      name: "Torta de Maracujá",
      category: "Sorvete 10L",
      image:
        "/massa/torta-maracuja.png",
      description:
        "Refrescante, equilibrado e com apelo visual forte.",
    },
    {
      name: "Torta de Limão",
      category: "Sorvete 10L",
      image:
        "/massa/torta-limao.png",
      description:
        "Sabor cítrico, leve e ideal para finalizar refeições.",
    },
  ];